$(document).ready(function () {
    var el = $('[data-cookies]');

    $('[data-closecookies]').on('click', function () {
        el.fadeOut();
        Cookies.set('cookies_info', '1', {expires: 12});
    });

    var myCookie = Cookies.get('cookies_info');
    if (myCookie === undefined) {
        el.show();
    }
});